/*
  v8.030 Universal keys strip. Fills every [data-eks-universal] slot with the
  Xhorse / Autel universal keys tagged for the vehicle make on the page.
  - Collection / finder results: the slot carries data-make (from the make: tag).
  - Search results: the slot carries data-terms; a make name is picked out of
    the search words (e.g. "lexus smart key" -> Lexus).
  The cards are rendered server-side by sections/eks-universal-keys.liquid on
  /collections/all/ufits:<Make>, so pricing and the wholesale gate match the
  rest of the site. No matching keys -> the slot stays empty and hidden.
*/
(function () {
  if (window.__eksUniversalKeys) return;
  window.__eksUniversalKeys = true;

  var MAKES = {
    'toyota': 'Toyota', 'lexus': 'Lexus', 'scion': 'Scion',
    'ford': 'Ford', 'lincoln': 'Lincoln', 'mercury': 'Mercury',
    'chevrolet': 'Chevrolet', 'chevy': 'Chevrolet', 'gmc': 'GMC', 'buick': 'Buick', 'cadillac': 'Cadillac',
    'chrysler': 'Chrysler', 'dodge': 'Dodge', 'jeep': 'Jeep', 'ram': 'RAM',
    'honda': 'Honda', 'acura': 'Acura',
    'nissan': 'Nissan', 'infiniti': 'Infiniti',
    'hyundai': 'Hyundai', 'kia': 'Kia', 'genesis': 'Genesis',
    'bmw': 'BMW', 'mini': 'Mini',
    'landrover': 'LandRover', 'land rover': 'LandRover', 'range rover': 'LandRover', 'jaguar': 'Jaguar',
    'volkswagen': 'Volkswagen', 'vw': 'Volkswagen', 'audi': 'Audi',
    'subaru': 'Subaru', 'mazda': 'Mazda', 'fiat': 'Fiat'
  };

  function makeFromTerms(terms) {
    var t = ' ' + String(terms || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ') + ' ';
    var keys = Object.keys(MAKES).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < keys.length; i++) {
      if (t.indexOf(' ' + keys[i] + ' ') > -1) return MAKES[keys[i]];
    }
    return '';
  }

  function fill(slot) {
    if (slot.dataset.eksUniversalReady) return;
    slot.dataset.eksUniversalReady = '1';
    var make = slot.dataset.make
      ? (MAKES[slot.dataset.make.toLowerCase().replace(/-/g, ' ')] || slot.dataset.make)
      : makeFromTerms(slot.dataset.terms);
    if (!make) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'collections/all/ufits:' + encodeURIComponent(make) + '?section_id=eks-universal-keys')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var strip = doc.querySelector('.eks-universal');
        if (!strip) return;
        // The search page lays its cards out with .search-results.
        if (slot.dataset.grid === 'search') {
          var grid = strip.querySelector('.product-grid');
          if (grid) grid.classList.add('search-results');
        }
        slot.innerHTML = '';
        slot.appendChild(document.importNode(strip, true));
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll('[data-eks-universal]').forEach(fill);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
